<div class="container bg-whitesmoke py-4">
  <app-breadcrumb></app-breadcrumb>
  
  <div class="download-page py-4" *ngIf="card">
<!-- QR Code Section (Deep Purple Background) -->
<!-- QR Code Section (Deep Purple Background) -->
<section class="qr-section-wrapper mb-4 p-4 rounded shadow-sm text-center" *ngIf="card?.handler" #qrSectionWrapper>
  <!-- Inner White Container -->
  <div class="qr-inner bg-white rounded-3 p-5 shadow-sm mx-auto">
    <!-- Section Title -->
    <h2 class="section-title mb-4">
      <i class="bi bi-qr-code me-2"></i> Share vCard
    </h2>

    <div class="d-flex flex-column align-items-center">
      <div class="qr-container position-relative mb-3">
        <canvas #qrCanvas></canvas>
        <div [class.hidden]="!qrLoading" class="spinner-overlay">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </div>

      <p class="mb-2 text-muted small">{{ environment.appUrl }}/{{ card.handler }}</p>

      <div class="d-flex justify-content-center gap-2 mb-3">
        <button mat-icon-button color="primary" (click)="copyHandlerLink()" matTooltip="Copy link">
          <mat-icon>content_copy</mat-icon>
        </button>
        <button mat-icon-button color="accent" (click)="shareHandlerLink()" matTooltip="Share link">
          <mat-icon>share</mat-icon>
        </button>
      </div>

      <ul class="info-list list-unstyled text-center mt-2 text-dark" *ngIf="card.contact_info">
        <li class="d-flex justify-content-center gap-3 mb-1 flex-wrap" *ngIf="card.contact_info?.contactName || card.contact_info?.primaryPhone">
          <span *ngIf="card.contact_info?.contactName"><strong>Name:</strong> {{ card.contact_info.contactName }}</span>
          <span *ngIf="card.contact_info?.primaryPhone"><strong>Phone:</strong> {{ formatPhone(card.contact_info.primaryPhone) }}</span>
        </li>
        <li *ngIf="card.contact_info?.primaryEmail"><strong>Email:</strong> {{ card.contact_info.primaryEmail }}</li>
      </ul>
    </div>
  </div>
</section>



  <!-- Download QR Button -->
  <div class="download-btn-wrapper">
    <button mat-raised-button color="warn" (click)="downloadQrSection()" [disabled]="qrLoading">
      <mat-icon>download</mat-icon> Download QR
    </button>
  </div>

  <!-- Digital Card Section -->
  <section class="card-section mb-4 p-4 bg-white rounded shadow-sm text-center" *ngIf="cardImageUrl">
    <h2 class="section-title mb-3">
      <i class="bi bi-credit-card-2-front me-2"></i> Digital Card
    </h2>
    <img [src]="cardImageUrl" alt="Card Image" class="mb-3 card-img-preview shadow-sm">
  </section>

  <!-- Download Card Button -->
  <div class="download-btn-wrapper">
    <button mat-raised-button color="primary" (click)="downloadCard()">
      <mat-icon>download</mat-icon> Download Card
    </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!card" class="text-center mt-5">
    <p class="text-muted">No card selected for download.</p>
  </div>
</div>